var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "14px",
    height: "14px",
    viewBox: "0 0 17.581 11.18",
    fill: "#323338",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "keyboard_backspace_black_24dp_1_",
    "data-name": "keyboard_backspace_black_24dp (1)",
    d: "M4.419,11h13.17l-2.88-2.88a1,1,0,0,1,1.41-1.41l4.59,4.59a1,1,0,0,1,0,1.41l-4.59,4.59a1,1,0,1,1-1.41-1.41L17.589,13H4.419a1,1,0,0,1,0-2Z",
    transform: "translate(-3.419 -6.469)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.1f9fbc5947bc65c4ebc6b2ee596a8b1d.svg";
export { ForwardRef as ReactComponent };